import React, { useId } from 'react';

export default function OtherWorkTypeInput({ value, onChange }) {
  const id = useId();
  if (value.type !== 'other') return null;
  return (
    <div className="field mt-3">
      <label htmlFor={id}>Type of work (optional)</label>
      <input
        id={id}
        className="field-input"
        placeholder="e.g. Drone coverage"
        value={value.custom_type || ''}
        onChange={(event) => onChange({ ...value, custom_type: event.target.value })}
        aria-describedby={`${id}-hint`}
      />
      <p id={`${id}-hint`} className="text-sm text-slate-500">Leave blank to use Other.</p>
    </div>
  );
}
